import { render } from "./TheFooter.vue?vue&type=template&id=4312bcb4&scoped=true"
const script = {}

import "./TheFooter.vue?vue&type=style&index=0&id=4312bcb4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4312bcb4"]])

export default __exports__